import axios from 'axios'
import { Message, Notification,MessageBox  } from 'element-ui'
import { store } from '@/store'
import { getToken, setToken,removeToken } from '@/utils/auth'
const token_name = 'my-token'
// const token_name = 'token'
// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 60000*4
})

// request interceptor
service.interceptors.request.use(config => {
  // // "window['my_token']=",window['my_token'])
  // // "getToken()=",getToken())
  const source = axios.CancelToken.source();
  config.cancelToken = source.token
  if(config.params){
    config.params['ver'] = process.env.VERSION
  }else{
    config.params = {ver:process.env.VERSION}
  }
  if (getToken() && getToken() != 'undefined') {
    if (!window['my_token']) {
      config.headers[token_name] = getToken()
    } else if (window['my_token'] != getToken()) {
      config.headers[token_name] = null

      return
    }
    config.headers[token_name] = getToken()

  }
  return config
}, error => {
  Message({
    message: '客户端请求时出错',
    type: 'error',
    duration: 1 * 1000
  })
  // error) // for debug
  Promise.reject(error)
}
)

// respone interceptor
service.interceptors.response.use(
  response => {
    if (response.headers[token_name] && response.headers[token_name] != 'undefined') {
      if (!window.my_token) {
        window['my_token'] = response.headers[token_name]
      } else {
        window.my_token = response.headers[token_name]
      }
      setToken(response.headers[token_name])
    }

    if (response.data.error_code == 50014) {
      if (window.vm.$route.name != 'loginPage' && window.vm.$route.path != '/') {
        // window.vm.loginForm.username = window.vm.$store.getters.name
        // window.vm.diagVisible = true;
        // window.vm.$router.push('/loginPage')
        // removeToken()
        // window.location.href='http://atrust.flzx3qc.cn:9005/osp-portal/template/login.html?service=https://shjz.mzt.xinjiang.gov.cn/mzjz-py-external-plugin/cas_security/check'
      }
    }
    if (response.data.error_code == 10005) {
      if (window.vm.$route.name != 'loginPage' && window.vm.$route.path != '/') {
        Message({
          message: response.data.remark,
          type: 'error',
          duration: 5 * 1000
        })
      }
    }
    return response
  },
  // response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过xmlhttprequest来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  // response => {
  //   const res = response.data
  //   if (res.code !== 20000) {
  //     Message({
  //       message: res.message,
  //       type: 'error',
  //       duration: 5 * 1000
  //     })
  //     // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
  //     if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
  //       // 请自行在引入 MessageBox
  //       // import { Message, MessageBox } from 'element-ui'
  //       MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
  //         confirmButtonText: '重新登录',
  //         cancelButtonText: '取消',
  //         type: 'warning'
  //       }).then(() => {
  //         store.dispatch('FedLogOut').then(() => {
  //           location.reload() // 为了重新实例化vue-router对象 避免bug
  //         })
  //       })
  //     }
  //     return Promise.reject('error')
  //   } else {
  //     return response.data
  //   }
  // },
  error => {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      Notification({
        type: 'error',
        title: '警告',
        message: error.response.data.remark,
        duration: 20 * 1000
      })
      // Message({
      //   showClose: true,
      //   message: error.response.data.remark,
      //   type: 'error',
      //   duration: 0
      // })
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      Notification.error({
        title: '服务端错误',
        message: '服务器未能响应',
        duration: 5 * 1000
      })
      // Message({
      //   message: '服务器未能响应',
      //   type: 'error',
      //   duration: 5 * 1000
      // })
      // // error.request)
    } else {
      if (error.message == "Cannot read properties of undefined (reading 'cancelToken')") {
        const h = this.$createElement;
        // MessageBox.alert('<h3 style="color:#ff0000;">请求时出错</h3> <p>系统检测到有新账号登录，<span style="color:#ff0000;">请勿使用不同账号同时登录系统。请关闭浏览器过10分钟后重新登录系统。<span>。</p> ', '警告',{
        //   dangerouslyUseHTMLString: true,
        //   showConfirmButton: true,
        //   showClose:false,
        //   closeOnClickModal: false,
        //   closeOnPressEscape: false,
        //   beforeClose: (action, instance, done) => {
        //     window.my_token = null
        //     done();
        //     instance.confirmButtonLoading = false;
        //     removeToken()
        //     window.vm.$router.push('/loginPage')
        //     // window.location.href='https://mzggfw.mzt.xinjiang.gov.cn/osp-portal/template/login.html?service=https://shjz.mzt.xinjiang.gov.cn/mzjz-py-external-plugin/cas_security/check'
        //   }
        // });
        // Notification.error({
        // title: '请求时出错',
        // message: "系统检测到有新账号登录，本账号将在10秒后退出登陆，请勿使用不同账号同时登录系统",
        // duration: 10 * 1000
        // })
      } else {
        // TODO 报错: "Cannot read property 'cancelToken' of undefined" 核实原因
        if(error.message == "Cannot read property 'cancelToken' of undefined"){
          Notification.error({
            title: '请求时出错',
            message: "登录异常",
            duration: 10 * 1000
          })
          // window.vm.$router.push('/loginPage')
          removeToken()
          window.vm.$router.push('/loginPage')
          // window.location.href='https://mzggfw.mzt.xinjiang.gov.cn/osp-portal/template/login.html?service=https://shjz.mzt.xinjiang.gov.cn/mzjz-py-external-plugin/cas_security/check'
          return
        }
        Notification.error({
        title: '请求时出错',
        message: error.message,
        duration: 10 * 1000
      })
      }

      // Message({
      //   message: '请求时出错：' + error.message,
      //   type: 'error',
      //   duration: 5 * 1000
      // })
      // Something happened in setting up the request that triggered an Error
      // 'Error2', error.message)
      //
    }

    return Promise.reject(error)
  }

)

const formDataService = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 60000,
  headers: { 'Content-Type': 'multipart/form-data' }
})

formDataService.interceptors.request.use(config => {
  // 'service config=', config)
  if (getToken() && getToken() != 'undefined') { config.headers[token_name] = getToken() }
  return config
}, error => {
  Message({
    message: '客户端请求时出错',
    type: 'error',
    duration: 5 * 1000
  })
  // error) // for debug
  Promise.reject(error)
}
)
formDataService.interceptors.response.use(
  response => {
    if (response.headers[token_name] && response.headers[token_name] != 'undefined') {
      setToken(response.headers[token_name])
    }

    if (response.data.error_code == 50014) {
      if (window.vm.$route.name != 'loginPage' && window.vm.$route.path != '/') {
        // window.vm.loginForm.username = window.vm.$store.getters.name
        // window.vm.diagVisible = true;
        // window.vm.$router.push('/loginPage')
        removeToken()
        window.vm.$router.push('/loginPage')
        // window.location.href='http://atrust.flzx3qc.cn:9005/osp-portal/template/login.html?service=https://shjz.mzt.xinjiang.gov.cn/mzjz-py-external-plugin/cas_security/check'
      }
    }
    if (response.data.error_code == 10005) {
      if (window.vm.$route.name != 'loginPage' && window.vm.$route.path != '/') {
        Message({
          message: response.data.remark,
          type: 'error',
          duration: 5 * 1000
        })
      }
    }
    return response
  },
  // response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过xmlhttprequest来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  // response => {
  //   const res = response.data
  //   if (res.code !== 20000) {
  //     Message({
  //       message: res.message,
  //       type: 'error',
  //       duration: 5 * 1000
  //     })
  //     // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
  //     if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
  //       // 请自行在引入 MessageBox
  //       // import { Message, MessageBox } from 'element-ui'
  //       MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
  //         confirmButtonText: '重新登录',
  //         cancelButtonText: '取消',
  //         type: 'warning'
  //       }).then(() => {
  //         store.dispatch('FedLogOut').then(() => {
  //           location.reload() // 为了重新实例化vue-router对象 避免bug
  //         })
  //       })
  //     }
  //     return Promise.reject('error')
  //   } else {
  //     return response.data
  //   }
  // },
  error => {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      Notification({
        type: 'error',
        title: '警告',
        message: error.response.data.remark,
        duration: 20 * 1000
      })
      // Message({
      //   showClose: true,
      //   message: error.response.data.remark,
      //   type: 'error',
      //   duration: 0
      // })
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      Notification.error({
        title: '服务端错误',
        message: '服务器未能响应',
        duration: 5 * 1000
      })
      // Message({
      //   message: '服务器未能响应',
      //   type: 'error',
      //   duration: 5 * 1000
      // })
      // // error.request)
    } else {
      Notification.error({
        title: '请求时出错',
        message: error.message,
        duration: 5 * 1000
      })
      // Message({
      //   message: '请求时出错：' + error.message,
      //   type: 'error',
      //   duration: 5 * 1000
      // })
      // Something happened in setting up the request that triggered an Error
      // 'Error1', error.message)
    }

    return Promise.reject(error)
  }

)
export default service




// WEBPACK FOOTER //
// ./src/utils/request.js